<div class="container">
    <div class="header">
        <div class="eap-header">
            <span class="description">
                {{
                    'system-settings.eap.led.description'
                    | translate: { num: eapLedList?.length, total:totalEapCount }
                }}
            </span>
            <div class="info-icon-container">
                <mat-icon
                    svgIcon="help"
                    class="help-icon"/>
                <div
                    class="info-message-container"
                    #infoMessage
                    [innerHTML]="'system-settings.eap.led.tooltip.text' | translate"
                ></div>
            </div>
        </div>
        <div class="eap-header">
            <app-button
                class="edit-button"
                text="system-settings.eap.led-pattern-settings.button"
                variant="edit"
                [iconButton]="true"
                iconSize="20px"
                icon="edit-pen"
                [disable]="!userCanEdit"
                (onClick)="showLedPatternSettings()">
            </app-button>
        </div>
    </div>
    <div class="table">
        <div class="row table-header">
            <div class="cell table-header">
                {{ 'system-settings.eap.led.table-header.no' | translate }}
            </div>
            <div class="cell table-header">
                {{ 'system-settings.eap.led.table-header.location' | translate }}
            </div>
            <div class="cell table-header">
                {{ 'system-settings.eap.led.table-header.pattern' | translate }}
            </div>
        </div>
        <ng-container *ngIf="!eapLedList || eapLedList?.length == 0">
            <div class="empty-groups-container">
                <mat-icon svgIcon="empty-box" class="empty-box-icon" />
                <div class="empty-groups-text">
                    {{ 'system-settings.eap.led.table.empty.1' | translate }}
                    <br />
                    {{ 'system-settings.eap.led.table.empty.2' | translate }}
                    <span class="channel-route-button" (click)="openEAPpage()">
                        {{ 'system-settings.eap.led.table.empty.3' | translate }}
                    </span>
                    {{ 'system-settings.eap.led.table.empty.4' | translate }}
                </div>
            </div>
        </ng-container>
        <ng-container *ngIf="eapLedList.length">
            <div class="row" *ngFor="let eap of eapLedList; let i = index" [class.disabled]="!userCanEdit">
                <div class="cell eap-number">
                    {{ i + 1 }}
                </div>
                <div class="cell">
                    <div class="location-wrapper">
                        {{ eap.location }}
                    </div>
                </div>
                <div class="cell">
                    <div class="pattern-wrapper">
                        {{ getPatternText(eap)}}
                        <div class="pattern-button-wrapper" (click)="selectPattern(eap)">
                            {{ getPatternButtonText(eap)}}
                        </div>
                    </div>
                    
                </div>
            </div>
        </ng-container>
    </div>
</div>

<app-confirmation-window
    #cancelConfirmation
    [mainLabel]="'system-settings.eap.cancel.dialog.title'"
    [discardLabel]="'system-settings.eap.cancel.dialog.discard'"
    [goBackLabel]="'system-settings.eap.cancel.dialog.go-back'"
    [saveLabel]="'system-settings.eap.cancel.dialog.save'">
</app-confirmation-window>

<app-loading-spinner *ngIf="isLoading" class="spinner-component"></app-loading-spinner>

